import { Gantt, gantt, Identifiable, List } from "@planzone/dto";
import { Event, events } from "@planzone/events";
import { reduceList } from "../list";
import { reduceProject } from "../project";
import { initialState } from "./initialState";

function canResize({ type }: Event) {
  return (
    type === events.editEventSucceeded ||
    type === events.editTaskSucceeded ||
    type === events.editMilestoneSucceeded ||
    type === events.editListSucceeded
  );
}

function getDateDiff(
  lists: Identifiable<List>[],
  nextLists: Identifiable<List>[],
) {
  const foundDiff = nextLists.find((list) =>
    lists.find(({ endDate }) => new Date(list.endDate) > new Date(endDate)),
  );

  return foundDiff ? foundDiff.endDate : null;
}

function resizeProject(
  project: Gantt["projects"][number],
  lists: Identifiable<List>[],
) {
  const nextEndDate = getDateDiff(lists, project.lists);

  return {
    ...project,
    rootList: {
      ...project.rootList,
      endDate: nextEndDate ? nextEndDate : project.rootList.endDate,
    },
  };
}

function propagateEvent(gantt: Gantt = initialState, event: Event): Gantt {
  const element: Identifiable<any> =
    event.type === events.removeTaskSucceeded
      ? event.data
      : event.type === events.removeListSucceeded
        ? event.data
        : event.type === events.removeMilestoneSucceeded
          ? event.data
          : event.type === events.removeEventSucceeded
            ? event.data
            : null;

  return {
    ...gantt,
    projects: gantt.projects.map((project) => {
      const nextLists = project.lists.map((list) => reduceList(list, event));
      const nextGantt = { ...reduceProject(project, event), lists: nextLists };

      return canResize(event)
        ? resizeProject(nextGantt, project.lists)
        : nextGantt;
    }),
    constraints: element
      ? gantt.constraints.filter(
          ({ originEntityUuid, targetEntityUuid }) =>
            originEntityUuid !== element.uuid &&
            targetEntityUuid !== element.uuid,
        )
      : gantt.constraints,
  };
}

export { propagateEvent };
